import pdfMake from 'pdfmake/build/pdfmake';
import JsBarcode from 'jsbarcode';
import moment from 'moment';
import { IStickerPdf } from '../../../../services/model/IStickerPdf';

export default async (data: IStickerPdf[], required: string) => {


  const vfsFonts = await import("pdfmake/build/vfs_fonts");
  const { vfs } = vfsFonts.pdfMake;
  pdfMake.vfs = vfs;

  const documentDefinition: any = {
    pageSize: {
      width: 290,
      height: 435
    },
    content: generateContent(data),
    pageMargins: [15, 10, 15, 10],
  };

  console.log("documentDefinition 创建完成");

  if (required === 'print') {
    console.log("执行 print 操作");
    pdfMake.createPdf(documentDefinition).print({});
  }
  if (required === 'view') {
    console.log("执行 view 操作");
    pdfMake.createPdf(documentDefinition).open();
  }

  console.log("=== product-stickers-pdf-generate 完成 ===");
};

// 根据文字长度动态调整字号，确保长名称也能适配固定高度区域
const getDynamicFontSize = (text: string): number => {
  const length = text.length;
  if (length > 100) return 9;
  if (length > 70) return 10;
  if (length > 50) return 11;
  return 12;
};

const getCartonSizeText = (item: IStickerPdf) => {
  if (item.cartonLength != null && item.cartonWidth != null && item.cartonHeight != null) {
    return `${item.cartonLength}×${item.cartonWidth}×${item.cartonHeight}`;
  }
  return '';
};

const textToBase64Barcode = (text: string) => {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, text, { 
    format: "CODE128",
    width: 2,
    height: 80,
    displayValue: false,
    margin: 0
  });
  return canvas.toDataURL('image/png');
};

const generateContent = (data: IStickerPdf[]) => {
  const content: any[] = [];

  data.forEach((item) => {
    // Header with logo and supplier info
    if (item.logoType == 4) {
      content.push({
        layout: 'noBorders',
        table: {
          widths: [80, '*'],
          body: [[
            item.logoBase64 ? 
              { image: item.logoBase64, width: 80, height: 80, margin: [0, 0, 0, 0] } : 
              { text: '' },
            {
              stack: [
                { text: 'Supplier Name:', fontSize: 11, alignment: 'center' },
                { text: 'Jadcup', bold: true, fontSize: 12, alignment: 'center' },
                { text: 'Vendor Number:', fontSize: 11, alignment: 'center' },
                { text: '3000039779', bold: true, fontSize: 12, alignment: 'center' }
              ],
              margin: [0, 10, 0, 0]
            }
          ]]
        },
        margin: [0, 0, 0, 3]
      });
    } else {
      content.push({
        layout: 'noBorders',
        table: {
          widths: ['*'],
          body: [[
            {
              image: item.logoBase64,
              width: 80,
              height: 80,
              alignment: 'center',
              margin: [0, 0, 0, 0]
            }
          ]]
        },
        margin: [0, 0, 0, 3]
      });
    }

    // Item Number
    content.push({
      table: {
        widths: ['*'],
        body: [[
          {
            text: [
              { text: 'Item Number: ', fontSize: 11 },
              { text: item.custProductCode?.toUpperCase(), fontSize: 12, bold: true }
            ],
            border: [false, true, false, true],
            alignment: 'center',
            margin: [0, 5, 0, 5]
          }
        ]]
      },
      margin: [0, 0, 0, 0]
    });

    // Product Name — 自动换行，无需手动拆分
    // let pname =  "LOVE CAFE-16OZ(290ML) Item Number: WB-SW16-LOVE CAFE Item Number: WB-SW16-LOVE CAFE Item Number: WB-SW16-LOVE CAFEItem Number: WB-SW16-LOVE CAFE"
// Product Name — 自动换行 + 上下居中
    content.push({
      table: {
        widths: ['*'],
        heights: [45],
        body: [[
          {
            text: item.productName.toUpperCase(),
            fontSize: getDynamicFontSize(item.productName),
            bold: true,
            alignment: 'center',
            border: [false, false, false, false],
            margin: [1, 0, 1, 0]
          }
        ]]
      },
      layout: {
        paddingLeft:   (_i: number, _node: any) => 1,
        paddingRight:  (_i: number, _node: any) => 1,
        paddingTop: (_i: number, _node: any) => {
          const cellHeight  = 55;
          const fontSize    = getDynamicFontSize(item.productName);
          const lineHeight  = fontSize * 1.35;          // pdfmake 默认行距约 1.35
          const usableWidth = 250;                       // 页面可用宽度(pt)，可按实际微调
          const avgCharWidth = fontSize * 0.55;          // 等宽估算
          const charsPerLine = Math.floor(usableWidth / avgCharWidth);
          const estimatedLines = Math.ceil(item.productName.length / charsPerLine);
          const contentHeight = lineHeight * estimatedLines;
          return Math.max(2, (cellHeight - contentHeight) / 2);
        },
        paddingBottom: (_i: number, _node: any) => 0,
      },
      margin: [0, 0, 0, 0]
    });

    // Quantity and Packaging Spec
    content.push({
      table: {
        widths: ['*', '*'],
        body: [
          [
            { text: 'Quantity:', fontSize: 11, border: [false, true, true, false], alignment: 'center' },
            { text: 'Packaging Spec:', fontSize: 11, border: [false, true, false, false], alignment: 'center' }
          ],
          [
            { text: item.quantity || '', fontSize: 12, bold: true, border: [false, false, true, true], alignment: 'center', margin: [0, -3, 0, 0] },
            { text: (item.sleeveQty === 1) ? 'N/A' : (item.packaging || ''), fontSize: 12, bold: true, border: [false, false, false, true], alignment: 'center', margin: [0, -3, 0, 0] }
          ]
        ]
      },
      margin: [0, 0, 0, 0]
    });

    // Batch Number
    content.push({
      text: [
        { text: item.batchNumber ? 'Batch number: ' : '', fontSize: 11 },
        { text: item.batchNumber || '', bold: true, fontSize: 12 }
      ],
      alignment: 'center',
      margin: [0, 6, 0, 4]
    });

    // Manufacture Date and Shelf Life
    content.push({
      table: {
        widths: ['*', '*'],
        body: [
          [
            { text: 'Manufacture Date:', fontSize: 11, border: [false, true, true, false], alignment: 'center' },
            { text: 'Shelf Life:', fontSize: 11, border: [false, true, false, false], alignment: 'center' }
          ],
          [
            { 
              text: item.manufactureDate ? 
                moment(item.manufactureDate).format('DD/MM/YYYY') : 
                moment().format('DD/MM/YYYY'),
              fontSize: 12,
              bold: true,
              border: [false, false, true, true],
              alignment: 'center',
              margin: [0, -2, 0, 0]
            },
            { 
              text: '2 Years',
              fontSize: 12,
              bold: true,
              border: [false, false, false, true],
              alignment: 'center',
              margin: [0, -2, 0, 0]
            }
          ]
        ]
      },
      margin: [0, 10, 0, 10]
    });

    // Barcode
    content.push({
      image: textToBase64Barcode(item.barcode),
      width: 208,
      height: 40,
      alignment: 'center',
      margin: [0, 5, 0, 5]
    });

    // Barcode number
    content.push({
      text: item.barcode,
      alignment: 'center',
      fontSize: 11,
      margin: [0, 0, 0, 0]
    });

    // Carton Size and GW
    content.push({
      table: {
        widths: ['70%', '30%'],
        body: [[
          {
            text: [
              { text: 'Carton Size(mm): ', fontSize: 11, bold: false },
              { text: getCartonSizeText(item), fontSize: 11, bold: true }
            ],
            border: [false, true, true, true],
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          {
            text: [
              { text: 'GW(KG): ', fontSize: 11, bold: false },
              { text: item?.grossWeigh ? item.grossWeigh : '', fontSize: 11, bold: true }
            ],
            border: [false, true, false, true],
            alignment: 'center',
            margin: [0, 5, 0, 5]
          }
        ]]
      },
      margin: [0, 5, 0, 5]
    });

    // Made in New Zealand
    content.push({
      text: 'Made in New Zealand',
      alignment: 'center',
      fontSize: 12,
      bold: true,
      margin: [0, 0, 0, 3]
    });

    // Page break between items
    if (data.indexOf(item) !== data.length - 1) {
      content.push({ text: '', pageBreak: 'after' });
    }
  });

  return content;
};